const Config = {
    hostname: "http://api.sepsurabaya.aldvintumbelaka.com"
}

export default Config;